/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {ClassifiedSubCategoriesListWrapper} from '../../modules/classified-module/subcategories/ClassifiedSubCategoriesList'

const ClassifiedSubCategoriesPage: FC = () => {
  const breadcrum: Array<PageLink> = [
    {
      title: 'Classified Module',
      path: '/classified-module',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return (
    <>
      <PageTitle breadcrumbs={breadcrum}>SubCategories</PageTitle>
      <ClassifiedSubCategoriesListWrapper />
    </>
  )
}

export {ClassifiedSubCategoriesPage}
